import React from 'react';
import { GraduationCap, Target, CheckCircle } from 'lucide-react';

const About = () => {
  return (
    <div data-testid="about-page" className="min-h-screen bg-gray-50">
      {/* Header */}
      <section className="bg-gradient-to-r from-blue-900 to-blue-800 text-white py-20 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl font-bold mb-4">Sobre Mim</h1>
            <div className="w-24 h-1 bg-yellow-400 mx-auto"></div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            {/* Image */}
            <div className="flex justify-center lg:justify-start">
              <img
                src="https://customer-assets.emergentagent.com/job_meslin-dev/artifacts/gbyh8spl_1000045144.png"
                alt="Fernando Meslin"
                data-testid="about-image"
                className="w-96 h-96 object-cover rounded-2xl shadow-2xl"
              />
            </div>

            {/* Text */}
            <div>
              <h2 className="text-3xl font-bold text-blue-900 mb-6">Fernando Meslin de Farias</h2>
              <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                Sou um profissional com sólida experiência em rotinas administrativas e financeiras,
                com foco em controle fiscal, retenções tributárias (IRRF, PIS, COFINS, CSLL, INSS, ISS),
                contas a pagar, conciliação bancária e elaboração de relatórios gerenciais.
              </p>
              <p className="text-lg text-gray-700 mb-4 leading-relaxed">
                Destaco-me pela organização, responsabilidade e domínio dos processos administrativos,
                além de experiência no apoio à diretoria e interface com contabilidade.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Perfil proativo, orientado para resultados, com facilidade em trabalho em equipe
                e cumprimento de prazos. Busco sempre contribuir para a eficiência das rotinas
                administrativas e financeiras das empresas onde atuo.
              </p>
            </div>
          </div>

          {/* Education Section */}
          <div className="bg-white rounded-2xl shadow-xl p-8 mb-12">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                <GraduationCap className="text-blue-900" size={24} />
              </div>
              <h2 className="text-3xl font-bold text-blue-900">Formação Acadêmica</h2>
            </div>
            <div className="space-y-6">
              <div data-testid="education-item-1" className="border-l-4 border-yellow-400 pl-6 py-2">
                <h3 className="text-xl font-semibold text-blue-900">Bacharel em Administração</h3>
                <p className="text-gray-600">Universidade Cândido Mendes - 1995</p>
              </div>
              <div data-testid="education-item-2" className="border-l-4 border-yellow-400 pl-6 py-2">
                <h3 className="text-xl font-semibold text-blue-900">Técnico em Contabilidade</h3>
                <p className="text-gray-600">Escola Técnica Cândido Mendes - 1985</p>
                <p className="text-sm text-gray-500">CRC nº RJ-119786/02</p>
              </div>
              <div data-testid="education-item-3" className="border-l-4 border-yellow-400 pl-6 py-2">
                <h3 className="text-xl font-semibold text-blue-900">Pós-Graduação (Lato Sensu)</h3>
                <p className="text-gray-600">Comportamento Organizacional e Gestão de Pessoas - ESAB</p>
              </div>
            </div>
          </div>

          {/* Objective Section */}
          <div className="bg-gradient-to-r from-blue-900 to-blue-800 text-white rounded-2xl shadow-xl p-8 mb-12">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center mr-4">
                <Target className="text-blue-900" size={24} />
              </div>
              <h2 className="text-3xl font-bold">Objetivo Profissional</h2>
            </div>
            <p className="text-lg leading-relaxed">
              Atuar como Assistente Administrativo, contribuindo para a eficiência das rotinas
              administrativas e financeiras da empresa, com foco em controle fiscal, contas a pagar,
              conciliação bancária e retenções tributárias.
            </p>
          </div>

          {/* Key Strengths */}
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <h2 className="text-3xl font-bold text-blue-900 mb-8 text-center">Principais Qualidades</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                'Organização e atenção aos detalhes',
                'Responsabilidade e comprometimento',
                'Proatividade e iniciativa',
                'Trabalho em equipe',
                'Cumprimento de prazos',
                'Facilidade de comunicação',
                'Adaptabilidade e flexibilidade',
                'Foco em resultados',
              ].map((quality, index) => (
                <div key={index} data-testid={`quality-${index}`} className="flex items-center space-x-3">
                  <CheckCircle className="text-green-500 flex-shrink-0" size={24} />
                  <span className="text-gray-700 text-lg">{quality}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;